export const generateUrl = (path, name) => {
    const q = path+"/"+name.toLowerCase().replace(/ /g , "-")

    return q
}

export const toUrl = (name) => {
    const q = name.toLowerCase().replace(/ /g , "-")

    return q
}

export const ucwords = (str) => {

    str = str.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });

    return str
}


// WEBPACK FOOTER //
// ./src/utils/text.js